import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import { TableElement, TableRenderElementProps } from '../types';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';

const AdminTablePDF = withDynamicBlogEditorPluginHydration()(dynamicEditorComponent(() =>
  import('./AdminTablePDF').then((mod) => mod.AdminTablePDF),
));
const AdminTableRow = withDynamicBlogEditorPluginHydration()(dynamicEditorComponent(() =>
  import('../../table-blog/components/AdminView/AdminTableRow').then((mod) => mod.AdminTableRow),
));
const AdminTableTDPDF = withDynamicBlogEditorPluginHydration()(dynamicEditorComponent(
  () => import('./AdminTableCellPDF').then((mod) => mod.AdminTableTDPDF),
  { dependsOn: AdminTablePDF },
));

export const renderElementTablePDF =
  (opts: TableRenderElementProps) => (props: RenderElementProps) => {
    const { element } = props;

    if (element.id) {
      switch (element.type) {
        case TableElement.TABLE: {
          return <AdminTablePDF {...props} {...opts} />;
        }
        case TableElement.TR: {
          return <AdminTableRow isReadOnly {...props} {...opts} />;
        }
        case TableElement.TH:
        case TableElement.TD: {
          return <AdminTableTDPDF {...props} {...opts} />;
        }
        default:
      }
    }
    return undefined;
  };
